import { useState } from 'react';
import { OnboardingEye } from '../Eye';
import BPInstruction from '../../BionicUI/instruction/BPInstruction';
import { SequenceItem } from './OnboardingProjectSequence';
import InputBar from '../InputBar';
import BPInput from '../../BionicUI/input/BPInput';
// import { PostUserProfileRequest } from 'core/models/users/profile/post-user-profile.model';
// import { UserV1BaseServerRepo } from 'core/repository/base-server/v1/user.repo';
// import { useAuth } from 'context/auth.context';
import { useNavigate } from 'react-router-dom';
import { ROUTES } from 'routes';
// import { usePrivy } from '@privy-io/react-auth';
import useOnboardingProjectStore from 'stores/onboardingProjectStore';

const ProjectName = () => {
  const [showInputBar, setShowInputBar] = useState<boolean>(false);
  const { nextStep, setProjectInfo, projectInfo } = useOnboardingProjectStore();
  const navigate = useNavigate();

  async function handleSubmit(inputText: string | null | undefined) {
    if (!inputText) return;
    setProjectInfo('name', inputText);
    nextStep();
  }

  return (
    <SequenceItem>
      <div className="flex justify-center w-full max-w-[800px] px-6 gap-[20px] mx-auto items-start">
        <OnboardingEye />
        <BPInstruction
          line1={{
            text: 'Please enter the name of your project.',
            sound: 'projectStep/please-enter-name-project.mp3',
          }}
          onAnimComplete={() => setShowInputBar(true)}
        />
      </div>
      {showInputBar && (
        <InputBar
          onClickBackButton={() => navigate(ROUTES.APPLICATION_IN_REVIEW)}
        >
          <BPInput
            value={projectInfo.name}
            state="default"
            type="text"
            placeholder="Enter your project name"
            button={{
              state: 'primary',
              onClick: (e, inputText) => handleSubmit(inputText),
              title: 'Submit',
            }}
            validate={(text) => text.length > 3}
          />
        </InputBar>
      )}
    </SequenceItem>
  );
};

export default ProjectName;
